import { AfterViewInit, ChangeDetectionStrategy, Component, EventEmitter, Inject, OnInit } from '@angular/core';
import { AbstractControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef, MatSnackBar } from '@angular/material';
import { ProfessorCategoryLegendComponent } from 'app/main/shared/components/professor-categories-legend/professor-categories-legend.component';
import { ApiService } from 'app/main/shared/services/api.service';
import { CustomValidator } from 'app/main/shared/validators/custom-validators';
@Component({
  selector: 'app-admin-edit',
  templateUrl: './admin-edit.component.html',
  styleUrls: ['./admin-edit.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AdminEditComponent implements OnInit, AfterViewInit {

  constructor(
    public dialogRef: MatDialogRef<AdminEditComponent>,
    @Inject(MAT_DIALOG_DATA) public datas: any,
    private api: ApiService,
    private snackBar: MatSnackBar,
    private dialog: MatDialog
  ) {//
    this.showErrorMatch = false;
  }


  // Form variable
  formGroup: FormGroup;

  // Banks for ABI
  relatedBanks: Array<any> = [];
  banks: Array<any> = [];

  // File uploading variables
  formData: FormData = new FormData();
  logoId = '';
  fileLoading: boolean;

  showErrorMatch: boolean;

  controlsArray: any[];

  // On change password emitter
  onChangePassword = new EventEmitter();
  onChangeUsername = new EventEmitter();
  onChangeRole = new EventEmitter();
  onSendingPushNotification = new EventEmitter();

  ngOnInit() {
    // Checks where dialog is opened from 
    if (this.datas) {
      this.formGroup = this.datas.formGroup;
      if (this.datas.passwords) {
        this.createControlsArray(this.datas.passwords, this.formGroup);
      }
      // if (this.datas.type === 'PROFESSOR' || this.datas.type === 'STUDENT') {
      //   if (this.formGroup.controls['username']) {
      //     this.formGroup.controls['username'].setValidators([Validators.required, CustomValidator.emailValidator]);
      //     this.formGroup.controls['username'].updateValueAndValidity();
      //   }
      // }
      if (this.formGroup.controls['username']) {
        this.formGroup.controls['username'].setValidators([Validators.required, CustomValidator.emailValidator]);
        this.formGroup.controls['username'].updateValueAndValidity();
      }
      if (this.formGroup.controls['hourlyCost']) {
        this.formGroup.controls['hourlyCost'].setValidators([CustomValidator.onlyPositiveNumber]);
        this.formGroup.controls['hourlyCost'].updateValueAndValidity();
      }
      if (this.formGroup.controls['maxNumStudents']) {
        this.formGroup.controls['maxNumStudents'].setValidators([CustomValidator.integerPositiveNumberExcludingZero]);
        this.formGroup.controls['maxNumStudents'].updateValueAndValidity();
      }
    }

  }

  createControlsArray(pass, form) {
    const controls = form.controls;
    this.controlsArray = [];
    const newArr = [];
    Object.keys(controls).forEach(el => {
      this.controlsArray[el] = controls[el];
      for (let x = 0; x < pass.length; x++) {
        if (pass[x].formControlName === el) {
          this.controlsArray[el].placeholder = pass[x].placeholder;
          this.controlsArray[el].type = pass[x].type;
          this.controlsArray[el].name = pass[x].formControlName;
          if (el === 'oldPassword') {
            this.controlsArray[el].sort = 0;
          } else if (el === 'password') {
            this.controlsArray[el].sort = 1;
          } else if (el === 'confirmPassword') {
            this.controlsArray[el].sort = 2;
          }
          newArr.push(this.controlsArray[el]);
        }
      }
    });
    this.controlsArray = newArr;
    this.controlsArray.sort((el1, el2) => {
      if (el1.sort > el2.sort) { return 1; }
      else if (el2.sort > el1.sort) {
        return -1;
      } else {
        return 0;
      }
    });
  }

  ngAfterViewInit() {
    // // Checks for data and sets to input 
    // if (this.datas && this.datas.data) {
    //   if (this.datas.data.name) {
    //     this.formGroup.controls.name.setValue(this.datas.data.name);
    //   }
    //   if (this.datas.data.ruolo) {
    //     this.formGroup.controls.role.setValue(this.datas.data.ruolo);
    //   }
    //   if (this.datas.data.surname) {
    //     this.formGroup.controls.surname.setValue(this.datas.data.surname);
    //   }
    //   if (this.datas.data.abi) {
    //     this.formGroup.controls.abi.setValue(this.datas.data.abi);
    //   }
    //   if (this.datas.data.tipo) {
    //     this.formGroup.controls.type.setValue(this.datas.data.tipo);
    //   }
    // }

  }


  // File uploading 
  documentInput(event) {
    const filesToUpload = <Array<File>>event.target.files;
    for (let i = 0; i < filesToUpload.length; i++) {
      this.formData.append('file', filesToUpload[i]);
    }
    this.api.postFileRequest('banca/logoUpload', this.formData)
      .subscribe((res: any) => {
        this.formGroup.controls.logo.setValue(res['payload']);
        this.newSnackbar('Logo caricato con successo', 'success');
      }, (err: any) => {
        console.error(err);
      }, () => {
      });
  }

  setRole(e) {
    // if (e.value === 'PROFESSOR' || e.value === 'STUDENT') {
    //   this.formGroup.controls['username'].setValidators([Validators.required, CustomValidator.emailValidator]);
    //   this.formGroup.controls['username'].updateValueAndValidity();
    // } else {
    //   this.formGroup.controls['username'].setValidators(Validators.required);
    //   this.formGroup.controls['username'].updateValueAndValidity();
    // }
    if (this.formGroup.controls['username']) {
      this.formGroup.controls['username'].setValidators([Validators.required, CustomValidator.emailValidator]);
      this.formGroup.controls['username'].updateValueAndValidity();
    }
    if (this.formGroup.controls['hourlyCost']) {
      this.formGroup.controls['hourlyCost'].setValidators([CustomValidator.onlyPositiveNumber]);
      this.formGroup.controls['hourlyCost'].updateValueAndValidity();
    }
    if (this.formGroup.controls['maxNumStudents']) {
      this.formGroup.controls['maxNumStudents'].setValidators([CustomValidator.integerPositiveNumberExcludingZero]);
      this.formGroup.controls['maxNumStudents'].updateValueAndValidity();
    }
  }

  // Sends data back
  async sendBank() {
    if (!this.formGroup.value['pushNotificationMsg']) {
      // this.dialogRef.close({
      //   data: this.formGroup.value
      // });
      this.datas.callback({ data: this.formGroup.value });
    } else {
      this.sendPushNotification();
    }

  }


  changePassword() {
    return this.onChangePassword.emit();
  }

  changeUsername() {
    return this.onChangeUsername.emit();
  }

  changeRole() {
    return this.onChangeRole.emit();
  }

  sendPushNotification() {
    return this.onSendingPushNotification.emit();
  }

  // New edit or create dialog
  newDialog(data: any, callback: any) {
    const dialog = this.dialog.open(AdminEditComponent, {
      width: '400px',
      maxHeight: '80vh',
      panelClass: 'custom-panel-class',
      data: data,
    });
    dialog.afterClosed().subscribe((datas: any) => {
      if (datas) {
        callback(datas);
      }
    });
  }


  // Opens new snackbar
  newSnackbar(text: any, snackBarClass: any) {
    return this.snackBar.open(`${text}`, '', {
      duration: 2000,
      panelClass: snackBarClass,
    });
  }

  // Checks password
  passwordConfirming(c: AbstractControl): { invalid: boolean } {
    if (c.get('password').value !== c.get('confirmPassword').value) {
      this.showErrorMatch = true;
      return { invalid: true };
    } else {
      this.showErrorMatch = false;
    }
  }

  openInfoDialog() {
    const dialog = this.dialog.open(ProfessorCategoryLegendComponent, {
      width: '400px',
      maxHeight: '90vh',
      panelClass: 'custom-panel-class',
      data: {

      }
    });
  }

}
